<template>
    <div style="background-color: #e8eef2">
        <PCNavbar selectIndex="2" />
        <MobileNavBar :currentActive="1" />
        <div class="data_brain_wrap">
            <el-row class="card_wrap" type="flex">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="政策查找" name="first" style="padding-right: 20px">
                        <div class="containt">
                            <div class="left">
                                <el-tree @check="treeCheckChangeisUse" :data="isUse" show-checkbox node-key="id"
                                    default-expand-all :expand-on-click-node="false">
                                    <div class="custom-tree-node" slot-scope="{ node, data }" style="
                      display: flex;
                      width: 100%;
                      justify-content: space-between;
                    ">
                                        <span>{{ data.label }}</span>
                                        <span>{{ data.count }}</span>
                                    </div>
                                </el-tree>
                                <el-tree @check="treeCheckChangestate" :data="state" show-checkbox node-key="id"
                                    default-expand-all :expand-on-click-node="false">
                                    <div class="custom-tree-node" slot-scope="{ node, data }" style="
                      display: flex;
                      width: 100%;
                      justify-content: space-between;
                    ">
                                        <span>{{ data.label }}</span>
                                        <span>{{ data.count }}</span>
                                    </div>
                                </el-tree>
                                <el-tree @check="treeCheckChangeaddress" :data="address" show-checkbox node-key="id"
                                    default-expand-all :expand-on-click-node="false">
                                    <div class="custom-tree-node" slot-scope="{ node, data }" style="
                      display: flex;
                      width: 100%;
                      justify-content: space-between;
                    ">
                                        <span>{{ data.label }}</span>
                                        <span>{{ data.count }}</span>
                                    </div>
                                </el-tree>

                                <el-tree @check="treeCheckChangeyearMonth" :data="yearMonth" show-checkbox
                                    node-key="label" :default-expanded-keys="expandedKeys"
                                    :expand-on-click-node="false">
                                    <div class="custom-tree-node" slot-scope="{ node, data }" style="
                      display: flex;
                      width: 100%;
                      justify-content: space-between;
                    ">
                                        <span>{{ data.label }}</span>
                                        <span>{{ data.count }}</span>
                                    </div>
                                </el-tree>
                                <el-tree @check="treeCheckChangepublishAgency" :data="publishAgency" show-checkbox
                                    node-key="id" default-expand-all :expand-on-click-node="false">
                                    <div class="custom-tree-node" slot-scope="{ node, data }" style="
                      display: flex;
                      width: 100%;
                      justify-content: space-between;
                    ">
                                        <span>{{ data.label }}</span>
                                        <span>{{ data.count }}</span>
                                    </div>
                                </el-tree>
                            </div>
                            <div class="right" style="background-color: #fff">
                                <el-input v-model="keyword" placeholder="请输入内容" style="width: 70%"></el-input>
                                <el-button type="primary" @click="search">搜索</el-button>

                                <div>
                                    <div v-for="(item, index) in rightData" :key="index" style="
                      font-size: 14px;
                      line-height: 2;
                      border-bottom: 1px solid #ccc;
                    ">
                                        <div  v-html="item.title"></div>
                                        <div v-html="item.fullText" style="color: #0009" v-if="keyword && showKey"></div>
                                        <div style="text-align: center" v-if="keyword  && showKey">
                                            {{
                                                '政策全文共提及"' +
                                                keyword +
                                                '"' +
                                            item.keyWordCount +
                                            "次"
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="政策分析" name="second">
                        <el-select v-model="fxYearMonth" placeholder="请选择">
                            <el-option v-for="item in yearMonthFX" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                        <div class="china-map" ref="map"></div>
                        <div class="china-map" ref="level"></div>
                        <div class="china-map" ref="type"></div>
                    </el-tab-pane>
                </el-tabs>
            </el-row>
        </div>

        <div style="
        cursor: pointer;
        font-size: 2ch;
        position: fixed;
        right: 0;
        top: 50%;
        padding: 0.6vw 1vw;
        color: #fff;
        background: linear-gradient(to right, #792ee7, #04c0cd);
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
      ">
            在线客服
        </div>
        <CallMe />
        <MobileCallme />
    </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";

import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
import {
    findGovernmentPolicyCount,
    getPhoneGovernmentPolicyList,
    getYearMonth,
    getCountByYear,
    getAdminCountyListByGovernmentPolicy,
} from "@/api/user.js";
import mapJson from "./china.json";
export default {
    data() {
        return {
            activeName: "first",
            isUse: [],
            address: [],
            publishAgency: [],
            state: [],
            keyword: "",
            expandedKeys: [],
            yearMonth: [],
            rightData: [],
            yearMonthFX: [],
            fxYearMonth: "",
            mapMaxcount: "",
            dataMap: [],
            datalevel: [],
            datatypeName: [],
            datatypeCount: [],
            CheckChangeisUse: [],
            CheckChangeaddress: [],
            CheckChangepublishAgency: [],
            CheckChangestate: [],
            CheckChangeyearMonth: [],
            showKey:false
        };
    },
    components: {
        PCNavbar,
        MobileNavBar,
        CallMe,
        MobileCallme,
    },
    mounted() {
       // this.getYearMonth();
    },
    created() {
        this.findGovernmentPolicyCount();
        this.getPhoneGovernmentPolicyList();
    },
    methods: {
        search() {
            this.getPhoneGovernmentPolicyList();
        },
        showType() {
            let myChart = this.$echarts.init(this.$refs.type);
            let option = {
                tooltip: {
                    show: true,
                },
                title: {
                    text: "政策发布类型",
                    textStyle: {
                        //主标题
                        color: "#3E4956",
                        fontWeight: "bold",
                        fontSize: 50,
                        fontFamily: "Haettenschweiler",
                    },
                    itemGap: 12, //主副标题之间的距离
                    //   top: "1%",
                    left: "center",
                },
                // legend: {
                //   data: [""],
                // },
                xAxis: [
                    {
                        type: "category",
                        data: this.datatypeName,
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: [
                    {
                        name: "",
                        type: "bar",
                        data: this.datatypeCount,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: "top", //在上方显示
                                    textStyle: {
                                        //数值样式
                                        color: "black",
                                        fontSize: 16,
                                    },
                                },
                            },
                        },
                    },
                ],
            };
            option && myChart.setOption(option);
        },
        showLevel() {
            let myChart = this.$echarts.init(this.$refs.level);
            let option = {
                color: ["#2ecc71", "#1abc9c", "#1abc9c", "#4ba477", "#3bbf7c"],
                title: {
                    text: "政策发布级别",
                    textStyle: {
                        //主标题
                        color: "#3E4956",
                        fontWeight: "bold",
                        fontSize: 50,
                        fontFamily: "Haettenschweiler",
                    },
                    itemGap: 12, //主副标题之间的距离
                    //   top: "1%",
                    left: "center",
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{b}: {c}",
                },
                calculable: true,
                series: [
                    {
                        name: "",
                        type: "treemap",
                        width: "88%",
                        height: "70%",
                        left: "10%",
                        roam: false, //是否开启拖拽漫游（移动和缩放）
                        nodeClick: false, //点击节点后的行为,false无反应
                        label: {
                            normal: {
                                textStyle: { fontWeight: "bold", fontSize: "14" },
                            },
                        },
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter: "{b}",
                                },
                                borderWidth: 2,
                                borderColor: "#ffffff",
                            },

                        },
                        data: this.datalevel,
                    },
                ],
            };
            option && myChart.setOption(option);
        },
        showMap() {
            let myChart = this.$echarts.init(this.$refs.map);
            // 注册地图
            this.$echarts.registerMap("china", mapJson);
            var option;
            option = {
                // 提示框组件
                tooltip: {
                    trigger: "item",
                    showDelay: 0,
                    transitionDuration: 0.2,
                    formatter: function (params) {
                        // 自定义 tooltip 的内容格式
                        return params.name + " : " + params.value;
                    },
                },
                // 视觉映射组件
                visualMap: {
                    orient: "horizontal", // 显示方式-水平
                    left: "left", // 距离容器左侧的位置-居中
                    min: 0, // 数据最小值
                    max: String(this.mapMaxcount) == '0' ? 1 : this.mapMaxcount, // 指定数据最大值
                    itemHeight: 200, // 组件高度-200px(设置显示方式为水平之后，组件高度即为宽度)
                    inRange: {
                        color: ["#c2e9ff", "#2662a9"], // 范围颜色-从小到大渐变颜色区间
                    },
                    calculable: true, // 是否启用数据项图形hover时的联动高亮效果。
                    // text: ["高", "低"], // 组件两侧的文本
                },
                series: [
                    {
                        name: "中国", // 地图名称
                        type: "map", // 系列类型-地图
                        map: "china", // 地图类型-与registerMap注册地图的名字相同
                        roam: false, // 是否开启鼠标缩放和平移漫游

                        zoom: 1.08, // 当前视角的缩放比例
                        select: {
                            disabled: true, // 数据项图形是否能被选中
                        },
                        label: {
                            normal: {
                                show: false, // 是否在数据图形上展示省份名称
                            },
                        },
                        data: this.dataMap,
                    },
                ],
            };
            option && myChart.setOption(option);
        },
        treeCheckChangeisUse(data, checked, indeterminate) {

            this.CheckChangeisUse = [];
            checked.checkedNodes.forEach(tem => {
                this.CheckChangeisUse.push(tem.label)
            })
            this.getPhoneGovernmentPolicyList();
          

        },
        treeCheckChangestate(data, checked, indeterminate) {
            this.CheckChangestate = [];
            checked.checkedNodes.forEach(tem => {
                this.CheckChangestate.push(tem.label)
            })
            this.getPhoneGovernmentPolicyList();
        },
        treeCheckChangeaddress(data, checked, indeterminate) {
            //  console.log('treeCheckChangeaddress',data,indeterminate);
            this.CheckChangeaddress = [];
            checked.checkedNodes.forEach(tem => {
                this.CheckChangeaddress.push(tem.postalCode)
            })
            this.getPhoneGovernmentPolicyList();
            // console.log(this.CheckChangeaddress);
        },
        treeCheckChangeyearMonth(data, checked, indeterminate) {
            this.CheckChangeyearMonth = [];
            checked.checkedNodes.forEach(tem => {
                this.CheckChangeyearMonth.push(tem.label)
            })
            this.getPhoneGovernmentPolicyList();
        },
        treeCheckChangepublishAgency(data, checked, indeterminate) {
            this.CheckChangepublishAgency = [];
            checked.checkedNodes.forEach(tem => {
                this.CheckChangepublishAgency.push(tem.label)
            })
            this.getPhoneGovernmentPolicyList();
        },
        async findGovernmentPolicyCount() {
            let ta = await findGovernmentPolicyCount();
            let tb = await getAdminCountyListByGovernmentPolicy();
            console.log("findGovernmentPolicyCount", ta, tb);
            this.isUse = [{ label: "政策有效性", children: ta.data.isUse }];
            this.publishAgency = [
                { label: "发布机构", children: ta.data.publishAgency },
            ];
            this.state = [{ label: "政策状态", children: ta.data.state }];
            this.yearMonth = [
                { label: "发布年份", children: ta.data.publishDateYear },
            ];
            let arr = [];
            ta.data.publishDateYear.forEach((res) => {
                arr.push({ label: res.label });
            });
            this.expandedKeys = ["发布年份"];
            this.address = [{ label: "适用地区", children: tb.data }];
        },
        /**
         * 获取当年和当月的政府政策数量
         */
        getYearMonth() {
            getYearMonth().then((res) => {
                console.log(res);
                if (res.code == "200") {
                    this.yearMonthFX = res.data;
                    this.fxYearMonth = res.data[0].label;
                    this.getCountByYear();
                }
            });
        },
        getPhoneGovernmentPolicyList() {
            this.showKey = false;
            let param = {
                page: 1,
                limit: 10,
                search: {
                    "postalCode": "",
                    "publishAgency": "",
                    "policyEffectiveness": "",
                    "state": "",
                    "keyWord": "",
                    "publishDateTime": "",
                },
            };
            if (this.keyword) {
                param.search.keyWord=this.keyword;
            }
            if (this.CheckChangeisUse) {
               let tarry =  [...new Set(this.CheckChangeisUse)];
              let t = tarry.filter((item) =>{
	                return item != "政策有效性"
                });
                 param.search.policyEffectiveness=t.join(",");
            }
            if (this.CheckChangeaddress) {
                let tarry =  [...new Set(this.CheckChangeaddress)];
                let t = tarry.filter((item) =>{
	                return item != "适用地区"
                });
                 param.search.postalCode=t.join(",");
            }
            if (this.CheckChangepublishAgency) {
                let tarry =  [...new Set(this.CheckChangepublishAgency)];
                let t = tarry.filter((item) =>{
	                return item != "发布机构"
                });
                 param.search.publishAgency=t.join(",");
            }
            if (this.CheckChangestate) {
                let tarry =  [...new Set(this.CheckChangestate)];
                let t = tarry.filter((item) =>{
	                return item != "政策状态"
                });
                 param.search.state=t.join(",");
            }
            if (this.CheckChangeyearMonth) {
                 let tarry =  [...new Set(this.CheckChangeyearMonth)];
                let t = tarry.filter((item) =>{
	                return item != "发布年份"
                });
                 param.search.publishDateTime=t.join(",");
            }
            getPhoneGovernmentPolicyList(param).then((res) => {
                console.log(res);
                if (res.code == "200") {
                    this.rightData = res.data;
                    this.showKey = true;
                }
            });
        },
        getCountByYear() {
            if (!this.fxYearMonth) return;
            let param = {
                yearMonth: this.fxYearMonth,
            };
            getCountByYear(param).then((res) => {
                if (res && res.code == "200") {
                    this.dataMap = res.data.province;
                    this.mapMaxcount = res.data.provinceCountMax;
                    this.datalevel = res.data.level;
                    this.datatypeName = res.data.typeNameList;
                    this.datatypeCount = res.data.typeCountList;
                    this.showMap();
                    this.showLevel();
                    this.showType();
                }
                console.log("getCountByYear", res);
            });
        },
        handleClick(tab, event) {
            this.activeName = tab.name;
            if(tab.name=='second'){
                 this.$nextTick(()=>{
                 this.getYearMonth();
            })
            }
           
            console.log(tab, event);
        },
    },
    components: {
        PCNavbar,
        MobileNavBar,
        CallMe,
        MobileCallme,
    },
};
</script>

<style lang="scss" scoped>
.el-tree{
    padding: 15px;
}
.china-map {
    height: 876px;
    /* 必须指定画布的高度 否则无法渲染 */
}

.containt {
    display: flex;
    justify-content: space-between;

    .left {
        width: 20%;
    }

    .right {
        width: 80%;
    }
}

.data_brain_wrap {
    padding: 70px 0;
    background: #e8eef2;
}

.card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    //   height: 2400px;
    border-radius: 8px;
    position: relative;

    @media screen and (max-width: 768px) {
        width: 95%;
    }

    .el-tabs {
        width: 100%;
    }
}

.bottom_circle {
    width: 100%;
    text-align: center;
    padding-top: 100px;
    background-image: url(../assets/img/smalldot.png),
        url(../assets/img/smalldot1.png);
    background-position: 0 0, 110% 150%;
    background-repeat: no-repeat;
    background-size: 400px;

    h1 {
        font-size: 40px;
        padding-bottom: 20px;

        @media screen and (max-width: 768px) {
            font-size: 1.15rem;
            width: 60%;
            margin: 0 auto;
        }
    }

    .circle_img {
        width: 100%;

        img {
            width: 70%;

            @media screen and (max-width: 768px) {
                width: 100%;
                margin: 20px 0;
            }
        }
    }
}
</style>
